import { useQuery } from '@tanstack/react-query';
import api from '../lib/api.js';
import { useScopeKey } from './useScopeKey.js';

export function useMonthSnapshot(month) {
  const scopeKey = useScopeKey();
  return useQuery({
    queryKey: ['month-snapshot', scopeKey, month ?? 'current'],
    queryFn: () => api.get(`/month-snapshot${month ? `?month=${month}` : ''}`),
    staleTime: 60_000,
    enabled: scopeKey !== 'loading',
  });
}
